<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
					<v-col cols="12" md="3" lg="3" class="mx-0 px-0">
                        <alternativeTextField2
                            @onChanged="(v) => {trySearch(v);}" 
                            :valueInput="tableProps.search"
                            :rule="[]"
                            :placeholder="'Buscar'"
                            :label="''"
                            data-cy="search-input"
                            :prependInnerIcon="'mdi-magnify'"
                            class="pick-3 mr-1"
                        ></alternativeTextField2>
					</v-col>
					<v-spacer></v-spacer>
					<v-col v-permission="'events.create'" cols="12" md="3" lg="2" class="mx-0 px-0 text-right">
                        <iconButton :props="createBtnData"></iconButton>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="mx-0 px-0"> 
						<datatable :props="tableProps" @method_handler="method_handler">
                            <template v-slot:item.date="props">
                                <span class="" v-if="props.item.date">{{ut.globalDateFormat(props.item.date)}}</span>
                            </template>

							<template v-slot:item.status="props">
								<v-chip :outlined="props.item.status == 'PENDIENTE'" :color="getChipColor(props.item.status)"><span :class="`${props.item.status == 'PENDIENTE'? 'grey--text' : 'white--text'}`">{{props.item.status}}</span></v-chip>
                            </template>
                        </datatable>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

        <modal :props="modalProps" @modalResponse="method_handler">
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" md="4">
						<secondaryButton
						:props="cancelModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" md="4">
						<primaryButton
						:props="acceptModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>


		<!-- Select employee to view answers -->
		<modal :props="modalSelectProps" @modalResponse="method_handler">
			<!-- Body -->
           
            <template slot="cardBody">
				
                <v-row class="mt-1">
                    <v-col>
                        <autocompleteOneForm
                            label="Evaluado"
                            :valueInput="selectedEvaluated"
                            :rule="[]"
                            :items="evaluated"
                            @valueChange="(v) => {selectedEvaluated = v;}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>
			</template>
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" md="4">
						<secondaryButton
						:props="cancelSelectModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" md="4">
						<primaryButton
						:props="acceptSelectModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>
		
	</div>
</template>
<script>
import Utils from '../../../helpers/Utils'
export default {
    data(){
		return {
            ut:Utils,
			selectedID: '',
			actions: [
				{
					name: 'Detalle',
					icon: {
						color: 'secondary',
						icon: 'mdi-information-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'performance_evaluations.show'
				},
				{
					name: 'Notificar',
					icon: {
						color: 'secondary',
						icon: 'mdi-share-variant-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'sendNotification',
					loading:false,
                    permissions: 'performance_evaluations.create'
				},
				{
					name: 'Resultados',
					icon: {
						color: 'secondary',
						icon: 'mdi-chart-box-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'openSelectModal',
                    permissions: 'performance_evaluations.show'
				},
				// {
				// 	name: 'Eliminar',
				// 	icon: {
				// 		color: 'secondary',
				// 		icon: 'mdi-delete-outline'
				// 	},
				// 	disabled: false,
				// 	type: 'method',   //  method, external, redirect
				// 	action: 'deleteItemModal',
                //     permissions: 'events.delete'
				// },
			],
			tableProps: {
				headers: [
					{
						text: 'Folio',
						align: 'left',
						value: 'id',
						class: 'table-b-border'
					},
                    {
						text: 'Evaluador',
						align: 'left',
						value: 'evaluator.name',
						class: 'table-b-border'
					},
                    {
						text: 'Evaluados',
						align: 'left',
						value: 'evaluatedCount',
						class: 'table-b-border'
					},
                    {
						text: 'Periodo',
						align: 'left',
						value: 'period',
						class: 'table-b-border'
					},
                    {
                        text: 'Fecha',
                        align: 'left',
                        value: 'date',
                        class: 'table-b-border'
                    },
                     {
                        text: 'Estatus',
                        align: 'left',
                        value: 'status',
                        class: 'table-b-border'
                    },
					{
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						class: 'table-b-border'
					}
				],
				items: [],
				search: '',
				loading: false,
				sortBy:'id',
				sortDesc:true
			},
			
            createBtnData: {
				hasTooltip:true,
                tooltip: 'Nueva evaluación',
                color:'primary',
                height:'35',
                text: "",
                icon: "mdi-plus",
				to: "EvaluationsCreate",
				block: true,
                click: ()=>{}
            },

			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			modalSelectProps: {
				visible: false,
				width: '500',
				title: 'Resultados',
				text: 'Selecciona a un evaluado para ver sus respuestas',
				loading: false,
				bottomLineColor: 'primary',
				
			},
			
			cancelModal: {
                text: "No, regresar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalProps.visible = false}
            },
			cancelSelectModal: {
                text: "Cerrar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalSelectProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
				loading:false,
                click: ()=>{this.delete()}
            },
			acceptSelectModal: {
                text: "Ver resultados",
                icon: "",
				to: "",
				block: true,
				color: 'primary',
				textColor:'',
				loading:false,
                click: ()=>{this.goToResults()}
            },
			selectedEvaluated:'',
			evaluated:[]
		}
	},

	mounted(){
		this.index();
	},

    methods: {
        method_handler(object){
			this[object.method_name](object.parameters)
		},
        trySearch(val){
            this.tableProps.search = val;
        },
		getChipColor(value)
		{
			switch (value) {
				case 'COMPLETO':
					return'#3B7071'

				case 'PENDIENTE':
					return '';

				default:
					return 'grey';
			}
		},
		goToResults()
		{
			if(this.selectedEvaluated == undefined || this.selectedEvaluated == '')
				return;

			const itemSelected = this.tableProps.items.find((x) => x.id == this.selectedID);
			const employee = itemSelected.evaluated.find((x) => x.employee.id == this.selectedEvaluated);
			console.log(employee)
			if(employee?.answers?.length > 0){
				
				this.$router.push(`/evaluaciones/${this.selectedID}/resultados/${this.selectedEvaluated}`);
				return;
			}
			this.$store.dispatch('snackbarError', `El evaluado no tiene resultados`);
		},
		index() {
			this.tableProps.loading = true;

			//call api
			this.$api.evaluation.index()
				.then((resp) =>{
					this.tableProps.items = resp.data.map((x,i) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actions))
						x['parameters'] = { id: x.id, name: x.name, index:i};
						x.actions[0].action = { name: 'EvaluationsDetails', params: { id: x.id } };
						// x.actions[2].action = { name: 'EvaluationsAnswers', params: { id: x.id, em } };
						// x.actions[1].action = { name: 'EventsEdit', params: { id: x.id } };

                        // x.status = x.status == "active" ? "Activo" : "Inactivo";

                        // x.start_date = Utils.globalDateFormat(x.start_date);
                        // x.end_date = Utils.globalDateFormat(x.end_date);
						x.date = x?.created_at?.split("T")[0]??'';
                        x.evaluatedCount = x?.evaluated?.length??0;

						return x
					});
				})
				.catch((error) =>{
					console.log(error, "error desde areas");
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
			//console.log(test);
			
			
			
		},

		openSelectModal(parameters)
		{
			this.selectedEvaluated = '';
			this.selectedID = parameters.id;

			this.evaluated = [];

			const itemSelected = this.tableProps.items.find((x) => x.id == parameters.id);
			this.evaluated = itemSelected.evaluated.map((x) => {
				return {text: x.employee.name, value: x.employee.id}
			});

			this.evaluated = this.evaluated.sort((a, b) =>{
				if (a.text < b.text) {
					return -1;
				}
				if (a.text > b.text) {
					return 1;
				}
				return 0;}
			);

			if(this.evaluated.length > 0){
				this.selectedEvaluated = this.evaluated[0].value;
			}


			this.modalSelectProps = {
				...this.modalSelectProps,
			}
			this.modalSelectProps.visible = true;
		},

		deleteItemModal(parameters){
			this.selectedID = parameters.id;
			this.modalProps = {
				...this.modalProps,
				text: `¿Estás seguro de eliminar "${parameters.name}"?`,
				
			}
			this.modalProps.visible = true;
			
		},
		delete(){
			this.acceptModal.loading = true;
			this.$api.evaluation.delete(this.selectedID)
			// eslint-disable-next-line
			.then((response) => {
				
				this.$store.dispatch('snackbarSuccess', `Se eliminó el activo`);
				this.index()
				// eslint-disable-next-line
			}).catch(error => {
				

				this.$store.dispatch('snackbarError', `Error al eliminar. Intenta de nuevo`);
			})
			.finally(() => {
				this.modalProps.visible = false;
				this.acceptModal.loading = false;
			})
		},
		sendNotification(props){
			console.log(props)
			
			this.tableProps.items[props.index].actions[1].loading = true;
			this.$api.evaluation.notify(props.id)
			// eslint-disable-next-line
			.then((response) => {
				
				this.$store.dispatch('snackbarSuccess', {title: 'Mensaje enviado', message: `Hemos enviado un correo al evaluador con los enlaces de llenado de las evaluaciones pendientes de responder`});

				// eslint-disable-next-line
			}).catch(error => {
				

				this.$store.dispatch('snackbarError', `Error. Intenta de nuevo`);
			})
			.finally(() => {
				this.tableProps.items[props.index].actions[1].loading = false;
			})
		},


    }
}
</script>